import { render, staticRenderFns } from "./DetailPurchaseInvoice.vue?vue&type=template&id=0b1cbdbe"
import script from "./DetailPurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./DetailPurchaseInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports